<template>
    <div class="hero">
        <div class="hero__container">
            <img :src="require(`../assets/img/lockup/${data.lockup}`)" alt="" >
            <h1 v-html="data.title"></h1>
            <h2 v-if="data.subtitle">{{  data.subtitle }}</h2>
        </div>
    </div>
</template>

<script>
import Content from '../data/content.js'
let lang = process.env.VUE_APP_LOCALITY;

export default {
  data: function() {
    return {
        data: Content[lang].hero,
    }
  },
};
</script>

<style>
    .hero {
        background: #ff8000;
        padding: 45px 0 100px;
    }

    .hero__container {
        max-width: 691px;
        margin: 0 auto;
        text-align: center;
    }

    .hero img {
        max-width: 289px;
        margin: 0 auto;
    }

    .hero h1 {
        color:#FFF;
        text-align: center;
        font-family: JETSansExtraBlack;
        font-size: 42px;
        font-weight: 1000;
        line-height: 105%; /* 44.1px */
    }

    .hero h2 {
        color: white;
        font-family: "JET Sans Digital";
        font-size: 26px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%; /* 31.2px */
        letter-spacing: -0.26px;
    }

    @media only screen and (max-width: 768px) { 
        .hero h1 {
            font-size: 30px;
        }

        .hero h2 {
            font-size: 20px;
        }
    }
</style>